export default {
  // AlimTalk Template
  search: 'Template Search',
  name: 'Enter Template Name',
  register: 'Register Template',
  tableChanel: 'Channel',
  tableTemplateName: 'Template Name',
  tableStatus: 'Registration Status',
  tableCreateDate: 'Registration Date & Time',
  tableDetails: 'Details',
  stateCaption: [
    'Registration: The template has been registered.',
    'Review Requested (Under Review): Waiting for approval after registration.',
    '*Once review is requested, the template cannot be edited. Editing is only possible after approval.',
    'Approved: The template has passed the review process.',
    'Rejected: The template was rejected due to issues found during the review.',
  ],
  registerIcon: 'Template Registration Icon',
  information2: '(Please register a new template if changes are needed.)',
  outgoingProfile: 'Sender Profile',
  category: 'Category',
  securityTemplateSettings: 'Secure Template Setting',
  securityCaption: 'When secure template is enabled, message content will not be shown on any sub-devices except the main mobile device.',
  securityCaptionNo: 'Item list type does not support secure template settings.',
  templateName: 'Template Name',
  upTo25Placeholder: 'Up to 25 characters',
  messageType: 'Message Type',
  messageBasic: 'Basic',
  messageAdditionalInformation: 'Additional Information',
  messageChannelAddition: 'Channel Add',
  messageCompound: 'Mixed',
  emphasizeType: 'Emphasize Type',
  notSelected: 'None',
  text: 'Emphasized Text',
  image: 'Image',
  itemList: 'Item List',
  emphasisTitle: 'Highlight Title',
  upTo50Placeholder: 'Up to 50 characters',
  upToPlaceholder: 'Up to {count} characters',
  emphasisAssistant: 'Highlight Subtitle',
  imageLabel: 'Image',
  selectFile: 'Select File',
  filePlaceholder: 'Please select a file.',
  imageSize1: 'Size Limit: Max width 500px, max height 250px / Must have 2:1 width-to-height ratio',
  imageSize2: 'File Format & Size: jpg, png / Up to 500KB',
  imageUse: 'Use Image',
  header: 'Header',
  headerUse: 'Enable Header',
  headerTitle: 'Header Title',
  headerPlaceholder: 'Up to 16 characters, variables allowed',
  itemHighlight: 'Item Highlight',
  itemHighlightUse: 'When item highlight is enabled, title and content fields are required.',
  itemTitle: 'Title',
  itemTitlePlaceholder: 'Up to {count} characters, variables allowed',
  itemTitlePlaceholder1: 'Up to 30 characters, variables allowed',
  itemTitlePlaceholder2: 'Up to 21 characters, variables allowed',
  itemContent: 'Content',
  itemContentPlaceholder1: 'Up to 19 characters, variables allowed',
  itemContentPlaceholder2: 'Up to 13 characters, variables allowed',
  itemHighlightImageUse: 'If an item highlight image or thumbnail is added, the item highlight title can be up to 21 characters and the content up to 13 characters.',
  itemHighlightImageSize1: 'Size Restriction: Minimum width 108px / Must have 1:1 aspect ratio',
  itemListLabel: 'Item List',
  addBtn: 'Add',
  deleteBtn: 'Delete',
  itemListName: 'Item Name',
  itemListNamePlaceholder: 'Up to 6 characters, variables not allowed',
  itemListContent: 'Item Content',
  itemListContentPlaceholder: 'Up to 23 characters, variables allowed',
  itemListDelete: 'Delete Option',
  itemSummary: 'Item Summary Info',
  itemSummaryUse: 'Use Item Summary Info',
  itemSummaryTitle: 'Info Title',
  itemSummaryTitlePlaceholder: 'Up to 6 characters, variables not allowed',
  itemSummaryContent: 'Info Content',
  itemSummaryContentPlaceholder: 'Up to 14 characters: numbers, units, or currency (e.g., 1,000, 5.0$, #{price}Won)',
  templateContent: 'Template Content',
  upTo1000Placeholder: 'Up to 1,000 characters',
  additionalInformation: 'Additional Information',
  upTo500Placeholder: 'Up to 500 characters',
  addChannelMessage: 'Channel Addition Notice Message',
  addChannelMessagePlaceholder: 'Add the channel to receive promotional and marketing messages from this channel.',
  addChannelMessageCaption1: 'If the message type is "Channel Add" or "Mixed", the "Add Channel" button is required, and a channel addition notice will be displayed at the bottom of the message.',
  addChannelMessageCaption2: '(For recipients who have already added the channel at the time of sending, the "Add Channel" button and guide message will not be displayed.)',
  button: 'Button',
  buttonType: 'Button Type',
  buttonName: 'Button Name',
  buttonLink: 'Button Link',
  buttonDelete: 'Delete Option',
  buttonCaption: 'Buttons can be added using the add button on the left.',
  modifyBtn: 'Edit',
  registerBtn: 'Submit',
  inspectionBtn: 'Request Review',
  transferTemplateBtn: 'Transfer Template',
  alimTalkArrived: 'AlimTalk Received',
  addChannelBtn: 'Add Channel',
  delivery: 'Track Delivery',
  webLink: 'Web Link',
  appLink: 'App Link',
  messageDelivery: 'Forward Message',
  upTo14Placeholder: 'Up to 14 characters',
  buttonMaxLength: 'Up to 5 buttons can be added.',
  deliveryPageCaption: 'AlimTalk message parsing will redirect users to the delivery tracking page provided by each courier.',
  mobilePlaceholder: 'Enter Mobile Link',
  pcPlaceholder: 'Enter PC Link',
  androidPlaceholder: 'Enter Android Link',
  iosPlaceholder: 'Enter iOS Link',
  imgSize500W: 'The image width is less than 500px.',
  imgSize250H: 'The image height is less than 250px.',
  imgratio21: 'The aspect ratio must be 2:1.',
  imgSize108W: 'The image width is less than 108px.',
  imgSize108H: 'The image height is less than 108px.',
  imgratio1: 'The aspect ratio must be 1:1.',
  differentExtensions: 'Invalid file extension.',
  fileSize500: 'The file size exceeds 500KB.',
  itemButtonMaxLength: 'Up to 10 buttons can be added.',

  information1: 'Templates with status "Review Requested", "Under Review", or "Approved" cannot be edited or deleted.',
  information3: 'Templates in "Draft" status can be edited from the list view.',
  information4: 'Templates in "Draft" status must be submitted for review from the list screen to be properly reviewed by Kakao.',
  requiredMsg: 'is required',
  messageTypeChannelAlert: 'If the message type is "Channel Add" or "Mixed", the "Add Channel" button is required, and a channel addition notice will be displayed at the bottom of the message.',

  registerCaption1: 'AlimTalk messages are informational and can be sent even to users who have not added the KakaoTalk channel. (They cannot be used for promotional purposes.)',
  registerCaption2: 'To prevent spam, only templates that pass the review process can be sent. You must click the "Request Review" button after registering a template for it to be reviewed.',
  registerCaption3: 'Personalized text can be written using the format #{variable}.',
  registerCaption3Sub: '(e.g., Hello #{Name} → Hello Hong Gil-dong)',
  registerCaption4: 'If the same variable name is used multiple times, it will be replaced with the same value throughout the message.',
  registerCaption4Sub: '(e.g., Hello #{Name}, This event is exclusively for #{Name}. → Hello Hong Gil-dong. This event is exclusively for Hong Gil-dong.)',
  registerCaption5: 'Fields where personalized text (#{variable}) can be used :',
  registerCaption6: 'Template content, Button name, Button link,',
  registerCaption7: '(If using Item List type) Header title, Item content, Item highlight title, Item highlight content',
  businessFormOptions: {
    surveys: 'Take a survey in Talk',
    applications: 'Apply in Talk',
    reservations: 'Make a reservation in Talk',
  },
  businessFormType: 'Business Form Type',
  businessFormID: 'Business ID',
};
